import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { useCurrentAccount } from '@mysten/dapp-kit';
import { listenForIncomingCalls, clearRing } from '../utils/voiceCall';

const CallContext = createContext(null);

export const useCall = () => useContext(CallContext);

export function CallProvider({ children }) {
  const currentAccount = useCurrentAccount();
  const [incomingCall, setIncomingCall] = useState(null); // { from, sessionId, ts }
  const [activeCall, setActiveCall]     = useState(null); // { otherAddress, otherName, mode, sessionId }
  const activeCallRef = useRef(null);

  useEffect(() => {
    if (!currentAccount?.address) return;
    let mounted = true;
    let sub = null;

    listenForIncomingCalls(currentAccount.address, (ring) => {
      if (!mounted) return;
      if (activeCallRef.current) return; // already in a call
      setIncomingCall(ring);
    }).then(s => { sub = s; }).catch(() => {});

    return () => {
      mounted = false;
      if (sub) { try { sub.close(); } catch (_) {} }
    };
  }, [currentAccount?.address]);

  const startCall = (otherAddress, otherName) => {
    const call = { otherAddress, otherName: otherName || otherAddress.slice(0, 6) + '...', mode: 'outgoing' };
    activeCallRef.current = call;
    setActiveCall(call);
  };

  const acceptCall = () => {
    if (!incomingCall) return;
    const call = {
      otherAddress: incomingCall.from,
      otherName: incomingCall.from.slice(0, 6) + '...' + incomingCall.from.slice(-4),
      mode: 'incoming',
      sessionId: incomingCall.sessionId,
    };
    activeCallRef.current = call;
    setActiveCall(call);
    setIncomingCall(null);
  };

  const declineCall = () => {
    if (incomingCall?.sessionId) clearRing(incomingCall.sessionId);
    setIncomingCall(null);
  };

  const endActiveCall = () => {
    activeCallRef.current = null;
    setActiveCall(null);
  };

  return (
    <CallContext.Provider value={{ startCall, endActiveCall, activeCall, incomingCall, acceptCall, declineCall }}>
      {children}
    </CallContext.Provider>
  );
}
